<template>
  <v-footer
    height="auto"
    fixed
    color="#6f6f6e"
  >
    <v-layout row wrap>
      <v-flex md6 class="text-xs-left" pl-4>
        <v-btn class="hidden-sm-and-down" color="white" round small flat @click="routeTo('https://edologic.de/impressum')">Impressum</v-btn>
        <v-btn class="hidden-sm-and-down" color="white" round small flat @click="routeTo('https://edologic.de/datenschutz')">Datenschutz</v-btn>
      </v-flex>

      <v-flex white--text pt-2 md6 class="text-xs-right" pr-4>
        <span v-if="config.isCloud">Cloud</span>
        <span v-if="!sasConfig.licenseValid">Free</span>
        <span v-if="sasConfig.licenseValid">Premium</span>
        &copy;2021 — <strong>edologic GmbH ({{version}})</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'main-footer',
  data: () => ({
    version: '',
    sasConfig: Vue.prototype.$sasConfig,
    config: Vue.prototype.$config,
    links: [
      'Home',
      'About Us',
      'Team',
      'Services',
      'Blog',
      'Contact Us'
    ]
  }),
  methods: {
    routeTo (url) {
      window.open(url, '_new')
    }
  },
  mounted () {
    this.version = '' + Vue.prototype.$config.VERSION
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footer/MainFooter.vue